import React, { FC } from 'react';
import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { ImageDescription } from 'components/structures/general';
import { contentMarketingImageBg, marketingAutomationImage, marketingAutomationImage2x } from 'images/digital-marketing';
import { greenSquareIcon } from 'images/contact-us';

const useStyles = makeStyles((theme: Theme) => ({
  imageWrapper: {
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
  },
  imageClass: {
    [theme.breakpoints.up('md')]: {
      position: 'static',
      borderRadius: theme.spacing(0, 4),
      maxWidth: 'calc(100% - 70px)',
      marginLeft: 'auto',
      display: 'block',
      margin: theme.spacing(0, 'auto'),
    },
  },
  borderImage: {
    [theme.breakpoints.up('md')]: {
      display: 'block',
      position: 'absolute',
      right: 30,
      width: '40%',
      bottom: 85,
      height: '33%',
      borderLeft: `40px solid ${theme.palette.switchedColors.main}`,
      borderTop: `30px solid ${theme.palette.switchedColors.main}`,
      borderRadius: theme.spacing(0, 4),
      backgroundColor: theme.palette.switchedColors.main,
      zIndex: -1,
    },
    [theme.breakpoints.up('lg')]: {
      right: 20,
      width: '50%',
      bottom: -15,
      height: '43%',
    },
  },
  miniSquare: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
      maxWidth: 95,
      width: '100%',
      position: 'absolute',
      left: 5,
      top: 35,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 120,
      top: -35,
    },
  },
}));

const MarketingAutomationBlock: FC = () => {
  const classes = useStyles();
  return (
    <ImageDescription
      image={{
        image: marketingAutomationImage,
        srcSet: `${marketingAutomationImage} 543w, ${marketingAutomationImage2x} 1085w`,
        imageClass: classes.imageClass,
        imageWrapperClass: classes.imageWrapper,
        imageElements: (
          <>
            <div className={classes.borderImage} />
            <img className={classes.miniSquare} src={greenSquareIcon} alt="square bg" />
          </>
        ),
        imageCenterLg: true,
      }}
      bgImage={{ image: contentMarketingImageBg }}
      upperTitle="Faster results"
      title="Marketing automation"
      text="Marketing automation implies using software and services to support digital advertising campaigns and improve advertising efficiency and relevance. It consists of optimization and automation of marketing tasks and work processes. At US Software Solutions, we are using dedicated tools and services to build a truly robust marketing campaign and deliver even greater results. All data is in metrics, and analysis shows how well the chosen strategy is working."
      gridItems={{ imageLg: 6, imageMd: 6, contentLg: 6, contentMd: 6 }}
    />
  );
};

export default MarketingAutomationBlock;
